// Apple Sign In — backend-initiated OAuth 2.0 flow for web.
// Step 1: Call GET /api/oauth/apple/init/ — backend generates + caches the CSRF state
//         and returns the full Apple authorization URL.
// Step 2: Redirect the browser to that URL so Apple POSTs directly to the backend.

import toast from "react-hot-toast";

const INIT_URL = `${process.env.REACT_APP_MAIN_URL}api/oauth/apple/init/`;

export async function initiateAppleLogin() {
    try {
        const res = await fetch(INIT_URL);
        if (!res.ok) throw new Error(`Init failed: ${res.status}`);
        const { auth_url } = await res.json();
        if (!auth_url) throw new Error("No auth_url returned from init endpoint");
        window.location.href = auth_url;
        return true;
    } catch (err) {
        console.error("Apple Sign In init error:", err);
        toast.error("Could not start Apple Sign In. Please try again.");
        return false;
    }
}
